import script from "./CatalogServiceDeleteModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogServiceDeleteModal.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogServiceDeleteModal.vue?vue&type=style&index=0&id=ceabc70a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ceabc70a"]])

export default __exports__